import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { EyeOff } from "lucide-react";

const url = (rid) => `${process.env.REACT_APP_BACKEND_URL}/api/lp/residents/${rid}/financial-review`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("nex_token")}` } });

/** Staff switch: while on, the resident's PACT Life Pass shows a holding message instead of any money. */
export default function FinancialReviewToggle({ rid }) {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { axios.get(url(rid), auth()).then((r) => setD(r.data)).catch(() => setD({ on: false })); }, [rid]);
  const set = (on) => {
    setBusy(true);
    axios.put(url(rid), { on }, auth()).then((r) => { setD(r.data); toast.success(on ? "Financial Review on · PACT Life Pass money hidden" : "Financial Review off · PACT Life Pass shows live money"); })
      .catch((e) => toast.error(e?.response?.data?.detail || "Couldn't change Financial Review")).finally(() => setBusy(false));
  };
  if (!d) return null;
  return (
    <label data-testid="financial-review-toggle" className={`flex items-center gap-3 p-3 border cursor-pointer ${d.on ? "border-amber-400/60 bg-amber-400/10" : "border-white/10"}`}>
      <input type="checkbox" checked={d.on} disabled={busy} onChange={(e) => set(e.target.checked)} data-testid="financial-review-checkbox" className="h-5 w-5 accent-[#d4a017]" />
      <EyeOff className={`h-4 w-4 shrink-0 ${d.on ? "text-amber-300" : "text-nex-muted"}`} />
      <span className="text-sm text-nex-silver font-semibold">Financial Review</span>
      <span data-testid="financial-review-status" className={`text-xs min-w-0 ${d.on ? "text-amber-200" : "text-nex-muted"}`}>
        {d.on ? `On · resident sees "being reviewed" instead of money${d.by?.name ? ` · by ${d.by.name}` : ""}` : "Off · resident sees their live money"}
      </span>
    </label>
  );
}
